var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.unreadCount > 0)?_c('van-notice-bar',{staticClass:"forum_unread_reply_notice",attrs:{"left-icon":"volume-o","mode":"link","scrollable":false,"text":_vm.noticeText},on:{"click":_vm.openMessages}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }